import { render } from "./RolesRegistro.vue?vue&type=template&id=40fc32f8"
import script from "./RolesRegistro.vue?vue&type=script&lang=js"
export * from "./RolesRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__